module.exports = __webpack_public_path__ + "static/media/image-7.4b5013bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-7.jpg
// module id = 284
// module chunks = 0